(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-limits/deposit-limits.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-limits/deposit-limits.js');
'use strict';

const {
  useEffect,
  useState
} = React;
const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const {
  PERIODS
} = svs.accountservicesReact.deposit.depositLimits.constants;
const service = svs.accountservicesReact.deposit.depositLimitsService;
const {
  DepositLimitsRow
} = svs.accountservicesReact.deposit.depositLimits;
const initLimits = () => PERIODS.map(i => ({
  limitType: i
}));
const DepositLimits = () => {
  const [limits, setLimits] = useState(initLimits());
  useEffect(() => {
    const getLimits = async () => {
      const {
        error,
        data
      } = await service.getDepositLimitsAsync();
      if (!error) {
        setLimits(data);
      }
    };
    getLimits();
    svs.components.account_balance.on('change', getLimits);
  }, []);
  return React.createElement("div", {
    className: "margin-bottom-1 margin-top-4 f-center"
  }, React.createElement(Icon, {
    className: "margin-bottom-2 u-block",
    icon: "deposit-limits",
    size: "900"
  }), React.createElement("h3", {
    className: "h3 margin-bottom-1"
  }, "Ins\xE4ttningsgr\xE4nser"), React.createElement("div", {
    className: "padding-bottom"
  }, limits.map(limit => React.createElement(DepositLimitsRow, {
    key: limit.limitType,
    limit: limit
  }))), React.createElement("div", {
    className: "margin-v-2"
  }, React.createElement(Button, {
    block: true,
    href: svs.core.urlMapping.get('myLimits'),
    transparent: true
  }, "Till mina gr\xE4nser")));
};
svs.accountservicesReact.deposit.depositLimits.DepositLimits = DepositLimits;

 })(window);